import { type LoaderFunction } from 'react-router';
import { clearSelectedTimeSlot } from '../../reducers/app/appReducer';
import store from '../../store';
import {
  getFollowUpPageData,
  initializeFollowUpPage,
} from './followUpLoaderHelper';

const followUpTimeSlotsPageLoader: LoaderFunction = () => {
  const pageData = getFollowUpPageData();
  initializeFollowUpPage(pageData, 'followup-timeslots');
  store.dispatch(clearSelectedTimeSlot());
  return pageData;
};

export default followUpTimeSlotsPageLoader;
